import React from 'react';
import {useTranslation} from 'react-i18next';
import './styles/errorModalCloseButton.scss';

interface IErrorModalCloseButtonProps {
    onClose: () => void;
    text?: string;
    className?: string;
}

function ErrorModalCloseButton({text, className, onClose}: IErrorModalCloseButtonProps): JSX.Element {
    const {t} = useTranslation();
    return (
        <button type="button" className={`${className || 'c-errorModalCloseButton'}`} onClick={onClose}>
            {text || t('common.close')}
        </button>
    );
}

export default ErrorModalCloseButton;
